"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stacks 2.0 Blockchain API
 * This is the documentation for the Stacks 2.0 Blockchain API.  It is comprised of two parts; the Stacks Blockchain API and the Stacks Core API.  <a href=\"collection.json\" download=\"collection.json\">Download Postman collection</a>
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddressTransactionWithTransfersToJSON = exports.AddressTransactionWithTransfersFromJSONTyped = exports.AddressTransactionWithTransfersFromJSON = void 0;
const runtime_1 = require("../runtime");
const _1 = require("./");
function AddressTransactionWithTransfersFromJSON(json) {
    return AddressTransactionWithTransfersFromJSONTyped(json, false);
}
exports.AddressTransactionWithTransfersFromJSON = AddressTransactionWithTransfersFromJSON;
function AddressTransactionWithTransfersFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'tx': json['tx'],
        'stx_sent': json['stx_sent'],
        'stx_received': json['stx_received'],
        'stx_transfers': (json['stx_transfers'].map(_1.AddressTransactionWithTransfersStxTransfersFromJSON)),
        'ft_transfers': !runtime_1.exists(json, 'ft_transfers') ? undefined : (json['ft_transfers'].map(_1.AddressTransactionWithTransfersFtTransfersFromJSON)),
        'nft_transfers': !runtime_1.exists(json, 'nft_transfers') ? undefined : (json['nft_transfers'].map(_1.AddressTransactionWithTransfersNftTransfersFromJSON)),
    };
}
exports.AddressTransactionWithTransfersFromJSONTyped = AddressTransactionWithTransfersFromJSONTyped;
function AddressTransactionWithTransfersToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'tx': value.tx,
        'stx_sent': value.stx_sent,
        'stx_received': value.stx_received,
        'stx_transfers': (value.stx_transfers.map(_1.AddressTransactionWithTransfersStxTransfersToJSON)),
        'ft_transfers': value.ft_transfers === undefined ? undefined : (value.ft_transfers.map(_1.AddressTransactionWithTransfersFtTransfersToJSON)),
        'nft_transfers': value.nft_transfers === undefined ? undefined : (value.nft_transfers.map(_1.AddressTransactionWithTransfersNftTransfersToJSON)),
    };
}
exports.AddressTransactionWithTransfersToJSON = AddressTransactionWithTransfersToJSON;
//# sourceMappingURL=AddressTransactionWithTransfers.js.map